import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import NoFooterLayout from "@/components/Layout/NoFooterLayout";
import MemberDetail from "./MemberDetail";

const MemberDetailWrapper: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleEdit = () => {
    navigate(`/profile/basic-information`, {
      state: { backUrl: globalThis.location.pathname },
    });
  };

  const handleBack = () => {
    const backUrl = location.state?.backUrl;
    if (backUrl) {
      navigate(backUrl);
    } else {
      navigate("/profile/family");
    }
  };

  return (
    <NoFooterLayout
      hideExit
      showEdit
      onEdit={handleEdit}
      onBack={handleBack}
      showTopBarGradient
      showFooter
    >
      <MemberDetail />
    </NoFooterLayout>
  );
};

export default MemberDetailWrapper;
